<template>
  <section id="home" class="hero relative">
    <div class="h-screen flex justify-center items-center">
      <div class="flex flex-col items-center">
        <div class="h-16 flex space-x-2 md:space-x-4 mb-5 wave">
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
          <div class="hidden md:block h-10 w-2 music_wave rounded-full"></div>
        </div>
        <p
          :class="[$root.isDarkMood ? 'text-slate-50' : 'text-black']"
          class="text-sm px-5 md:px-0 text-center md:text-xl"
        >
          Life is full of ups and downs. Just like this little music wave.
        </p>
        <p class="text-sm px-5 md:px-0 text-center md:text-xl font-bold my-3">
          <span class="hi">HI !</span>
          <span class="text-3xl text-blue-600 italic">"</span>
          <span class="exp">I am PK and I am a Web Developer</span>
          <span class="text-3xl text-blue-600 italic">"</span>
        </p>
        <div class="space-x-3">
            <a href="/portfolio/pk_resume.pdf" download="resume" class="
              download_cv
              rounded-lg
              px-1
              py-3
              md:px-2 md:py-3
              font-bold
              text-xs
              md:text-sm
            ">Download Resume</a>
          <a
            href="#about_me"
            class="
              about_me_btn
              px-1
              py-3
              md:px-2 md:py-3
              rounded-lg
              font-bold
              text-xs
              md:text-sm
            "
            >About Me</a
          >
        </div>

        <div
          class="
            animate-bounce
            rounded-full
            flex
            justify-center
            items-center
            lg:hidden
            w-10
            h-10
            menu_bar_bg
            mt-10
          "
        >
          <a href="#about_me">
            <svg
              class="w-6 h-6 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div
      class="
        hidden
        rounded-full
        lg:flex
        flex-col
        space-y-10
        justify-center
        items-center
        absolute
        bottom-20
        lg:right-56
      "
    >
      <span class="rotate-90">scroll down</span>
      <div class="animate-bounce">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
export default {
};
</script>

<style>
</style>